import React from 'react';
import List from '../../../Components/Global/Lists';

export const Footer_Text = [
  {
    textSize: '1.25rem',
    textMobile: '0.625rem',
    renderContent: () => (
      <span>© 2026 KUTER S.A.P.I. de C.V. Todos los derechos reservados.</span>
    ),
  },
];

export const Legal_Title = [
  {
    textSize: '1.5rem',
    marginBottom: '0.563rem',
    textMobile: '0.75rem',
    renderContent: () => <span>AVISOS Y POLÍTICAS</span>,
  },
];

export const Legal_List = [
  {
    text: 'AVISO LEGAL',
    dataTarget: 'legal-notice',
    click: true,
  },
  {
    text: 'AVISO DE PRIVACIDAD',
    dataTarget: 'privacy-notice',
    click: true,
  },
  {
    text: 'POLÍTICAS DE PRIVACIDAD',
    dataTarget: 'privacy-policies',
    click: true,
  },
];

export const Warning = [
  {
    textSize: '2rem',
    marginBottom: '0px',
    fontWeight: '400',
    lineHeight: '1.4',
    textMobile: '0.75rem',
    renderContent: () => (
      <span>
        A toda la comunidad:
        <br />
        <br />
        Han estado circulando diversas solicitudes de casting por parte de KUTER
        Casa Productora, utilizando números de teléfono y plataformas como
        Facebook y WhatsApp que no pertenecen a nuestro equipo.
        <br />
        <br />
        Queremos informarles que estas solicitudes son completamente FALSAS.
        Ningún miembro de nuestro equipo solicita fotos de desnudos o en ropa
        interior por ningún medio, y no realizamos ningún casting mediante
        videollamada.
        <br />
        <br />
        Todos nuestros castings se publican exclusivamente a través de nuestros
        canales oficiales en Facebook e Instagram. Además, colaboramos con
        agencias de casting certificadas en la industria.
        <br />
        <br />
        Les rogamos reportar estas publicaciones y verificar siempre con los
        canales oficiales de las casas productoras. Extendemos una invitación a
        compartir esta información para que nadie sea víctima de este tipo de
        situaciones.
      </span>
    ),
  },
];

export const Legal_Notice = [
  {
    textSize: '1.75rem',
    marginBottom: '0px',
    fontWeight: '400',
    lineHeight: '1.3',
    textMobile: '0.75rem',
    renderContent: () => (
      <span>
        AVISO LEGAL
        <br />
        <br />
        Los créditos señalados así como las obras, contenido y material
        audiovisual de este sitio web, son únicamente informativos con la
        finalidad de dar a conocer las creaciones de KUTER Casa Productora,
        siendo del Cliente todos los derechos de Propiedad Intelectual que de
        las mismas deriven.
        <br />
        <br />
        Queda prohibido el uso o reproducción total o parcial de los contenidos
        expuestos en este sitio web sin el consentimiento por escrito tanto de
        McGuffin Casa Productora S.A. de C.V., Largometrajes S.A. de C.V. y/o
        KUTER S.A.P.I. de C.V., así como del Cliente o Marca para quien fue
        desarrollada la Producción.
        <br />
        <br />
        Todas las Producciones expuestas dentro de este sitio web le pertenecen
        a la Marca y/o al Solicitante y fueron elaboradas bajo la asesoría o
        bajo encargo de manera total o parcial por asociados o empleados de
        McGuffin Casa Productora S.A. de C.V., Largometrajes S.A. de C.V. y/o
        KUTER S.A.P.I. de C.V.
        <br />
        <br />
        Para mayor información, favor de ponerse en contacto con personal de
        McGuffin Casa Productora S.A. de C.V., Largometrajes S.A. de C.V. y/o
        KUTER S.A.P.I. de C.V., en la sección correspondiente de este mismo
        sitio web.
      </span>
    ),
  },
];

export const Privacy_Notice = [
  {
    textSize: '1.875rem',
    marginBottom: '0px',
    fontWeight: '400',
    lineHeight: '1.3',
    textMobile: '0.75rem',
    textType: 'div',
    renderContent: () => (
      <span>
        AVISO DE PRIVACIDAD
        <br />
        Aviso de privacidad para Clientes de KUTER Casa Productora
        <br />
        <br />
        I.- Identidad y domicilio del Responsable. De conformidad con lo
        establecido en la Ley Federal de Protección de Datos Personales en
        Posesión de los Particulares (en adelante referida como la “Ley”), así
        como de su Reglamento, le informamos que las empresas McGuffin Casa
        Productora S.A. de C.V., Largometrajes S.A. de C.V. y/o KUTER S.A.P.I.
        de C.V. (en lo sucesivo KUTER Casa Productora), (el “Responsable”), con
        domicilio en Zamora 169, interior 2 , Col. Condesa, alcaldía Cuauhtémoc,
        C.P. 06140, Ciudad de México, (la “Dirección de contacto”), tratará los
        datos personales que recabe de Usted, en los términos del presente Aviso
        de Privacidad.
        <br />
        <br />
        II.- Finalidades del tratamiento de datos personales recabados.
        <br />
        <br />
        El tratamiento de los datos recabados se hará con las siguientes
        finalidades:
        <br />
        <br />
        A: Necesarias para la relación jurídica con el Responsable.
        <List
          textSize={'1.875rem'}
          textTransform={'none'}
          marginBottom={'0px'}
          textMobile={'0.75rem'}
          dataList={ListPrivacy}
        />
        <br />
        <br />
        B: Otras
        <List
          textSize={'1.875rem'}
          textTransform={'none'}
          marginBottom={'0px'}
          textMobile={'0.75rem'}
          dataList={ListPrivacy2}
        />
        <br />
        <br />
        Por lo tanto y para alcanzar las finalidades antes expuestas, se
        tratarán los siguientes datos personales: nombres, apellidos, dirección,
        teléfono (móvil y fijo), RFC, registros de propiedad, registro patronal
        del IMSS, nacionalidad, país de residencia, tipo de servicio requerido,
        nombre del contacto, teléfono del contacto, correo electrónico del
        contacto, reportes del servicio, sector, giro y los siguientes datos
        financieros o patrimoniales: principales instituciones de crédito en las
        cuales tenga cuentas bancarias, sucursales, números de cuenta, y número
        de CLABE.
        <br />
        <br />
        III.- Opciones y medios para limitar el uso o divulgación de sus datos.
        Usted podrá acudir al departamento de Recursos Humanos del Responsable
        para efectuar la solicitud de limitación de uso o divulgación de sus
        datos personales, de acuerdo a lo establecido en el presente Aviso de
        Privacidad.
        <br />
        <br />
        IV.- Medios para ejercer los derechos de Acceso, Rectificación,
        Cancelación u Oposición (los “Derechos ARCO”).
        <br />
        <br />
        Usted tiene el derecho de: (I) acceder a sus datos personales en nuestro
        poder y conocer los detalles del tratamiento de los mismos, (II)
        rectificarlos en caso de ser inexactos o incompletos, (III) cancelarlos
        cuando considere que no se requieren para alguna de las finalidades
        señaladas en el presente aviso de privacidad, estén siendo utilizados
        para finalidades no consentidas o haya finalizado la relación
        contractual o de servicio, u (IV) oponerse al tratamiento de los mismos
        para fines específicos, según lo establece la ley.
        <br />
        <br />
        Para el ejercicio de sus Derechos ARCO, deberá presentar una solicitud
        (la “Solicitud ARCO”), al Responsable, a la atención del departamento de
        Recursos Humanos, a la Dirección de Contacto y/o a la dirección de
        correo electrónico productora@kuter.com.mx, acompañada de la siguiente
        información y documentación:
        <br />
        <br />
        <List
          textSize={'1.875rem'}
          textTransform={'none'}
          marginBottom={'0px'}
          textMobile={'0.75rem'}
          dataList={ListPrivacy3}
        />
        <br />
        <br />© 2026 KUTER S.A.P.I. de C.V. Todos los derechos reservados.
      </span>
    ),
  },
];

const ListPrivacy = [
  {
    text: 'Para generar una base de datos de los clientes.',
  },
  {
    text: 'Para mejorar el control y realización de los procesos subsecuentes de consulta',
  },
  {
    text: 'Para prestar el servicio adecuadamente.',
  },
  {
    text: 'Para celebrar un contrato para que el Responsable preste sus servicios, tales como reclutamiento y selección, administración de nómina, entre otros.',
  },
];

const ListPrivacy2 = [
  {
    text: 'Efectuar transferencias de datos con terceros, conforme a lo establecido en el Aviso de Privacidad, según corresponda.',
  },
];

const ListPrivacy3 = [
  {
    text: 'Nombre y domicilio del titular de los datos personales, o cualquier otro medio de contacto que permita comunicarnos con él, con la finalidad de atender y dar respuesta a su solicitud.',
  },
  {
    text: 'Los documentos que acrediten su identidad (INE, Pasaporte, Cédula Profesional, o cualquier identificación oficial), o en su caso, la representación legal del titular, deberán presentarse en original en la dirección de contacto, a fin de que el responsable pueda emitir la respuesta correspondiente.',
  },
  {
    text: 'El titular deberá hacer una descripción clara y precisa de los datos personales respecto de los cuales busca ejercer alguno de los derechos, así como qué tipo de derecho solicita ejercer.',
  },
];

export const Privacy_Policies = [
  {
    textSize: '1.875rem',
    marginBottom: '0px',
    fontWeight: '400',
    lineHeight: '1.35',
    textMobile: '0.75rem',
    renderContent: () => (
      <span>
        POLÍTICAS DE PRIVACIDAD
        <br />
        <br />
        KUTER Casa Productora (McGuffin Casa Productora S.A. de C.V.,
        Largometrajes S.A. de C.V. y/o KUTER S.A.P.I. de C.V.) siempre se ha
        comprometido a mantener la exactitud, la confidencialidad y la seguridad
        de su información personal y corporativa. Hemos establecido los
        principios de privacidad para gobernar nuestro uso de la información del
        cliente. KUTER Casa Productora (McGuffin Casa Productora S.A. de C.V.,
        Largometrajes S.A. de C.V. y/o KUTER S.A.P.I. de C.V.) no vende,
        comparte o distribuye la información del cliente a ninguna organización
        de terceros.
        <br />
        <br />
        Rendición de cuentas
        <br />
        <br />
        KUTER Casa Productora (McGuffin Casa Productora S.A. de C.V.,
        Largometrajes S.A. de C.V. y / o KUTER S.A.P.I. de C.V.) es responsable
        de mantener y proteger la información del cliente bajo su control.
        <br />
        <br />
        Identificación de propósitos
        <br />
        <br />
        Se identificará el propósito para el cual el cliente recopila
        información antes o al tiempo que se recoge la información.
        <br />
        <br />
        Consentimiento
        <br />
        <br />
        El conocimiento y consentimiento del cliente son necesarios para la
        recolección, uso o divulgación de su información, excepto cuando sea
        requerida o permitida por la ley.
        <br />
        <br />
        Limitación de colección
        <br />
        <br />
        La información del cliente recopilada debe limitarse a los detalles
        necesarios para los propósitos identificados por KUTER Casa Productora
        (McGuffin Casa Productora S.A. de C.V., Largometrajes S.A. de C.V. y / o
        KUTER S.A.P.I. de C.V.) la información debe ser recopilada por medios
        justos y legales.
        <br />
        <br />
        Limitación de uso, divulgación y retención
        <br />
        <br />
        La información del cliente sólo puede ser utilizada o divulgada con la
        finalidad que motivó su recopilación, salvo que el cliente haya
        consentido lo contrario, o cuando su uso sea requerido o permitido por
        la ley. La información del cliente sólo podrá mantenerse durante el
        período de tiempo necesario para cumplir el propósito para el cual fue
        recopilada.
        <br />
        <br />
        Autenticidad
        <br />
        <br />
        La información de los clientes deberá mantenerse precisa, completa y
        actualizada, a fin de cumplir con los fines para los cuales resulte
        necesaria.
        <br />
        <br />
        Seguridad de la información del cliente
        <br />
        <br />
        La información del cliente debe estar protegida por garantías de
        seguridad apropiadas para el nivel de sensibilidad de la información.
        <br />
        <br />
        Accesibilidad
        <br />
        <br />
        KUTER Casa Productora (McGuffin Casa Productora S.A. de C.V.,
        Largometrajes S.A. de C.V. y/o KUTER S.A.P.I. de C.V.) respeta que todas
        las personas incluyendo las que estén en condiciones de vulnerabilidad
        puedan ejercer en forma independiente, los derechos humanos de acceso a
        la información y protección de datos personales en igualdad de
        condiciones con las demás, sin que sea obstáculo para ello el entorno
        físico, la información, las comunicaciones, incluidos los sistemas y las
        tecnologías de la información, así como las telecomunicaciones y otros
        servicios e instalaciones abiertos al público o de uso general, tanto en
        zonas urbanas como rurales.
        <br />
        <br />
        Divulgación de información del cliente
        <br />
        <br />
        A petición, el cliente deberá ser informado de la existencia y se le
        otorgará acceso a la misma. Asimismo, uso y divulgación de su
        información y se le otorgará acceso a la misma. Los clientes podrán
        verificar la exactitud e integridad de su información y podrán solicitar
        su rectificación, actualización o modificación, cuando corresponda.
        <br />
        <br />
        Manejo de quejas y sugerencias
        <br />
        <br />
        Los clientes pueden dirigir cualquier pregunta o consulta con respecto a
        los principios de privacidad descritos anteriormente o sobre nuestras
        prácticas, comunicándose con la persona designada responsable de la
        privacidad en KUTER Casa Productora (McGuffin Casa Productora S.A. de
        C.V., Largometrajes S.A. de C.V. y/o KUTER S.A.P.I. de C.V.).
        <br />
        <br />
        Exclusión voluntaria
        <br />
        <br />
        Si desea cancelar la suscripción, por favor envíe correo electrónico a
        productora@kuter.com.mx, comunicación escrita a Zamora 169 interior 2,
        Colonia Condesa, alcaldía Cuauhtémoc, C.P. 06140, Ciudad de México o
        llámenos al +52 55-6842-5431.
      </span>
    ),
  },
];
